<template>
  <div class="theme">
    <div class="pao pao2 wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="theme_content">
      <div class="linear_word">THEME ACTIVITY</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">主题活动</div>
      </div>
      <div class="theme_detail">
        <div @click="backList" class="btn_close"></div>
        <div class="detail_heard">
          <p class="detail_title">{{detail.news_title}}</p>
          <p class="detail_message">文章来源：{{detail.news_author}}&nbsp;&nbsp;&nbsp;&nbsp;发表日期：{{$time(detail.news_time)}}</p>
        </div>
        <div class="detail_con my_topic" v-html="detail.news_content"></div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
export default {
  components: { myMenu, myBottom, },
  data() {
    return {
      detail: {},
    }
  },

  mounted() {
    var newsId = this.$route.query.id
    P_getNewsDetail({
      news_id: newsId,
    }).then((res) => {
      if (res.success) {
        this.detail = res.data
      }
    })
  },
  methods: {
    initWow(zoom) {
      var top = $('.theme_detail').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
    backList() {
      this.$router.push({
        path: '/theme',
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.theme {
  .pao1 {
    left: 620px;
    top: 700px;
  }
  .theme_content {
    width: 1320px;
    margin: 150px auto 180px;
    position: relative;
    z-index: 1;
    .theme_detail {
      margin-top: 74px;
      padding: 64px;
      box-shadow: 0px 8px 40px 0px rgba(232, 160, 46, 0.3);
      border-radius: 40px;
      background: #fff;
      position: relative;
      .btn_close {
        width: 109px;
        height: 109px;
        position: absolute;
        background-image: url('../assets/icon_close.png');
        background-size: contain;
        right: -20px;
        top: -55px;
        cursor: pointer;
        transition: all 0.6s;
        &:hover {
          transform: rotate(360deg);
        }
      }
      .detail_heard {
        border-bottom: 1px solid #00000044;
        .detail_title {
          font-size: 36px;
          font-family: SourceHanSansCN;
          font-weight: bold;
          color: #1f1f1f;
          text-align: center;
        }
        .detail_message {
          font-size: 19px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #1f1f1f;
          text-align: center;
          line-height: 46px;
        }
      }
      .detail_con {
        margin-top: 44px;
      }
    }
  }
}
.pao2 {
  border-radius: 50%;
  background-image: -moz-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -webkit-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -ms-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  opacity: 0.7;
  left: -200px;
  top: 1003px;
  width: 303px;
  height: 303px;
}
img {
  width: 100%;
}
</style>